import { Directive } from '@angular/core';
import { DestroyableComponent } from './destroyable.component';

@Directive()
export abstract class StepComponent extends DestroyableComponent {
	abstract isValid(): boolean;
	abstract save(): void;
}
